/* eslint-disable @typescript-eslint/no-magic-numbers */ /* eslint-disable @typescript-eslint/no-unnecessary-condition */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Calendar", {
    enumerable: true,
    get: function() {
        return Calendar;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _ProgressCircle = require("../ProgressCircle/ProgressCircle");
const _luxon = require("luxon");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _groupBy = /*#__PURE__*/ _interop_require_default(require("lodash/groupBy"));
const _localisationeq1 = require("@equiem/localisation-eq1");
const _Theme = require("../../contexts/Theme");
const _hooks = require("../../hooks");
const _CalendarNavigation = require("./CalendarNavigation");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const MINS_IN_HOUR = 60;
const generateDays = (activeTime)=>{
    const weekStart = activeTime.startOf("week");
    return Array(7).fill(null).map((_, i)=>weekStart.plus({
            day: i
        }));
};
const generateHours = (language)=>{
    const oneAm = _luxon.DateTime.fromFormat("1", "h");
    var _oneAm_zoneName;
    const formatter = Intl.DateTimeFormat(language, {
        hour: "numeric",
        timeZone: (_oneAm_zoneName = oneAm.zoneName) !== null && _oneAm_zoneName !== void 0 ? _oneAm_zoneName : undefined
    });
    return Array(23).fill(null).map((_, i)=>formatter.format(oneAm.plus({
            hour: i
        }).toJSDate()));
};
const populateSelectedTime = (time, timezone)=>{
    if ((time === null || time === void 0 ? void 0 : time.start) != null && (time === null || time === void 0 ? void 0 : time.end) != null) {
        const start = _luxon.DateTime.fromMillis(time.start, {
            zone: timezone
        });
        const end = _luxon.DateTime.fromMillis(time.end, {
            zone: timezone
        });
        return {
            start,
            end
        };
    }
    // if only one side is specified, pretend it's a 30 minute event but clamp the
    // times to make sure they stay on the same day
    if ((time === null || time === void 0 ? void 0 : time.start) != null) {
        const start = _luxon.DateTime.fromMillis(time.start, {
            zone: timezone
        });
        const end = _luxon.DateTime.min(start.plus({
            minutes: 30
        }), start.endOf("day"));
        return {
            start,
            end
        };
    }
    if ((time === null || time === void 0 ? void 0 : time.end) != null) {
        const end = _luxon.DateTime.fromMillis(time.end, {
            zone: timezone
        });
        const start = _luxon.DateTime.max(end.minus({
            minutes: 30
        }), end.startOf("day"));
        return {
            start,
            end
        };
    }
    return null;
};
const isToday = (date, timezone)=>date.hasSame(_luxon.DateTime.local({
        zone: timezone
    }), "day");
const isDisplayed = (timestamp, activeTime, timezone)=>_luxon.DateTime.fromMillis(timestamp, {
        zone: timezone
    }).hasSame(activeTime, "week");
const BlockedTime = (param)=>{
    let { start, end, timezone } = param;
    const { colors } = (0, _Theme.useTheme)();
    const startTime = _luxon.DateTime.fromMillis(start, {
        zone: timezone
    });
    const endTime = _luxon.DateTime.fromMillis(end, {
        zone: timezone
    });
    const gridRowStart = startTime.hour * MINS_IN_HOUR + startTime.minute + 1;
    const gridRowEnd = endTime.hour * MINS_IN_HOUR + endTime.minute + 1;
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "event ".concat(start, "-").concat(end),
        style: {
            gridRowStart,
            gridRowEnd,
            background: colors.grayscale[20]
        }
    });
};
const SelectedTime = (param)=>{
    let { start, end, timezone } = param;
    const { i18n } = (0, _localisationeq1.useTranslation)();
    const { colors, spacers } = (0, _Theme.useTheme)();
    const time = populateSelectedTime({
        start,
        end
    }, timezone);
    if (time == null) {
        return null;
    }
    const gridRowStart = time.start.hour * MINS_IN_HOUR + time.start.minute + 1;
    const gridRowEnd = time.end.hour * MINS_IN_HOUR + time.end.minute + 1;
    const captionTextHeight = 12; // line height
    const captionHeight = captionTextHeight + 2 * 8; // line height +  2 * y-margin
    const eventHeight = gridRowEnd - gridRowStart; // 1 grid row = 1 min = 1px
    const showCaption = eventHeight >= captionTextHeight;
    const isShort = eventHeight < captionHeight;
    const timeStr = [
        start != null && _localisationeq1.formatters.timeshort(time.start, i18n.language, {
            timezone
        }),
        end != null && _localisationeq1.formatters.timeshort(time.end, i18n.language, {
            timezone
        })
    ].filter((token)=>typeof token === "string").join(" - ").toLowerCase();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        title: timeStr,
        style: {
            gridRowStart,
            gridRowEnd
        },
        className: _style.default.dynamic([
            [
                "3e35f08240add45a",
                [
                    colors.primary,
                    colors.blue[10],
                    spacers.s3,
                    spacers.s3
                ]
            ]
        ]) + " " + "event selected-time ".concat(gridRowStart, "-").concat(gridRowEnd, " ").concat(isShort ? "short-event" : "")
    }, showCaption && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "3e35f08240add45a",
                [
                    colors.primary,
                    colors.blue[10],
                    spacers.s3,
                    spacers.s3
                ]
            ]
        ]) + " " + "caption"
    }, timeStr)), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "3e35f08240add45a",
        dynamic: [
            colors.primary,
            colors.blue[10],
            spacers.s3,
            spacers.s3
        ]
    }, ".selected-time.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;border-left:2px solid ".concat(colors.primary, ";background:").concat(colors.blue[10], ";overflow:hidden}.selected-time.short-event.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.caption.__jsx-style-dynamic-selector{display:inline-block;font-size:12px;font-weight:600;line-height:12px;margin:8px ").concat(spacers.s3, ";-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.short-event.__jsx-style-dynamic-selector .caption.__jsx-style-dynamic-selector{margin:0 ").concat(spacers.s3, "}")));
};
const Calendar = (param)=>{
    let { timezone, selectedDate, selectedTime, autoScrollCurrentTime = true, getBlockedTimesCb } = param;
    const { i18n } = (0, _localisationeq1.useTranslation)();
    const theme = (0, _Theme.useTheme)();
    const calendarRef = (0, _react.useRef)(null);
    const [activeTimeMs, setActiveTime] = (0, _react.useState)(selectedDate.toMillis());
    const [loading, setLoading] = (0, _react.useState)(false);
    const [rawBlockedTimes, setRawBlockedTimes] = (0, _react.useState)([]);
    const activeTime = _luxon.DateTime.fromMillis(activeTimeMs, {
        zone: timezone
    });
    const days = generateDays(activeTime);
    const hours = generateHours(i18n.language);
    const blocked = (0, _groupBy.default)(rawBlockedTimes, (param)=>{
        let { start } = param;
        return _luxon.DateTime.fromMillis(start, {
            zone: timezone
        }).day;
    });
    var _selectedTime_start, _ref;
    const selectedTimeBase = (_ref = (_selectedTime_start = selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.start) !== null && _selectedTime_start !== void 0 ? _selectedTime_start : selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.end) !== null && _ref !== void 0 ? _ref : null;
    const selectedTimeDay = selectedTimeBase != null && isDisplayed(selectedTimeBase, activeTime, timezone) ? _luxon.DateTime.fromMillis(selectedTimeBase, {
        zone: timezone
    }).day : null;
    const scrollHour = selectedTimeBase != null && isDisplayed(selectedTimeBase, activeTime, timezone) ? _luxon.DateTime.fromMillis(selectedTimeBase, {
        zone: timezone
    }).hour : _luxon.DateTime.local({
        zone: timezone
    }).hour;
    (0, _react.useEffect)(()=>{
        if (autoScrollCurrentTime && calendarRef.current != null) {
            calendarRef.current.scrollTo({
                top: (scrollHour - 2) * MINS_IN_HOUR,
                behavior: "smooth"
            });
        }
    }, [
        autoScrollCurrentTime,
        calendarRef,
        scrollHour
    ]);
    const processTime = async (newTime)=>{
        if (loading) {
            return;
        }
        try {
            setLoading(true);
            const evs = await getBlockedTimesCb(newTime);
            setRawBlockedTimes(evs);
            setActiveTime(newTime.toMillis());
        } finally{
            setLoading(false);
        }
    };
    const debouncedSelectedDate = (0, _hooks.useDebounced)(selectedDate, 500);
    (0, _react.useEffect)(()=>{
        // eslint-disable-next-line no-console
        processTime(debouncedSelectedDate).catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedSelectedDate.toFormat("yyyy-LL-dd")
    ]);
    const reset = async ()=>processTime(_luxon.DateTime.local({
            zone: timezone
        }));
    const prevWeek = async ()=>processTime(activeTime.minus({
            week: 1
        }));
    const nextWeek = async ()=>processTime(activeTime.plus({
            week: 1
        }));
    // As a general rule, rolling your own custom localised formatters like this
    // is a bad idea and should be avoided.
    // However, in this case, these custom date formats are only relevant for the
    // calendar view and we explicitly *don't* want them reused elsewhere.
    const monthFormatter = new Intl.DateTimeFormat(i18n.language, {
        month: "long",
        year: "numeric",
        timeZone: timezone
    });
    const dayFormatter = new Intl.DateTimeFormat(i18n.language, {
        weekday: "short",
        timeZone: timezone
    });
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "calendar-cont"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "header"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "font-weight-bold"
    }, monthFormatter.format(activeTime.toJSDate())), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ])
    }, loading ? /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
        size: "sm",
        className: "calendar-loading mr-4"
    }) : null, /*#__PURE__*/ _react.default.createElement(_CalendarNavigation.CalendarNavigation, {
        loading: loading,
        prev: prevWeek,
        next: nextWeek,
        reset: reset
    }))), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "cal-holder"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "dates-heading"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "time-spacer"
    }), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "dates"
    }, days.map((d)=>/*#__PURE__*/ _react.default.createElement("div", {
            key: d.day,
            className: _style.default.dynamic([
                [
                    "6f046df116ebb685",
                    [
                        theme.spacers.s6,
                        theme.breakpoints.lg,
                        theme.colors.border,
                        theme.spacers.s5,
                        theme.colors.border,
                        theme.colors.border,
                        theme.breakpoints.md + 1
                    ]
                ]
            ]) + " " + "date ".concat(d.toFormat("cccd").toLowerCase(), " ").concat(isToday(d, timezone) ? "today" : "")
        }, /*#__PURE__*/ _react.default.createElement("span", {
            className: _style.default.dynamic([
                [
                    "6f046df116ebb685",
                    [
                        theme.spacers.s6,
                        theme.breakpoints.lg,
                        theme.colors.border,
                        theme.spacers.s5,
                        theme.colors.border,
                        theme.colors.border,
                        theme.breakpoints.md + 1
                    ]
                ]
            ]) + " " + "mr-2"
        }, dayFormatter.format(d.toJSDate())), /*#__PURE__*/ _react.default.createElement("span", {
            className: _style.default.dynamic([
                [
                    "6f046df116ebb685",
                    [
                        theme.spacers.s6,
                        theme.breakpoints.lg,
                        theme.colors.border,
                        theme.spacers.s5,
                        theme.colors.border,
                        theme.colors.border,
                        theme.breakpoints.md + 1
                    ]
                ]
            ]) + " " + "date-number"
        }, d.day))))), /*#__PURE__*/ _react.default.createElement("div", {
        ref: calendarRef,
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "calendar"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "times"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "spacer"
    }), hours.map((h)=>/*#__PURE__*/ _react.default.createElement("div", {
            key: h,
            className: _style.default.dynamic([
                [
                    "6f046df116ebb685",
                    [
                        theme.spacers.s6,
                        theme.breakpoints.lg,
                        theme.colors.border,
                        theme.spacers.s5,
                        theme.colors.border,
                        theme.colors.border,
                        theme.breakpoints.md + 1
                    ]
                ]
            ]) + " " + "time"
        }, /*#__PURE__*/ _react.default.createElement("span", {
            className: _style.default.dynamic([
                [
                    "6f046df116ebb685",
                    [
                        theme.spacers.s6,
                        theme.breakpoints.lg,
                        theme.colors.border,
                        theme.spacers.s5,
                        theme.colors.border,
                        theme.colors.border,
                        theme.breakpoints.md + 1
                    ]
                ]
            ])
        }, h)))), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6f046df116ebb685",
                [
                    theme.spacers.s6,
                    theme.breakpoints.lg,
                    theme.colors.border,
                    theme.spacers.s5,
                    theme.colors.border,
                    theme.colors.border,
                    theme.breakpoints.md + 1
                ]
            ]
        ]) + " " + "days"
    }, days.map((d)=>{
        var _d_weekdayShort, _blocked_d_day;
        return /*#__PURE__*/ _react.default.createElement("div", {
            key: d.toISO(),
            className: _style.default.dynamic([
                [
                    "6f046df116ebb685",
                    [
                        theme.spacers.s6,
                        theme.breakpoints.lg,
                        theme.colors.border,
                        theme.spacers.s5,
                        theme.colors.border,
                        theme.colors.border,
                        theme.breakpoints.md + 1
                    ]
                ]
            ]) + " " + "day ".concat((_d_weekdayShort = d.weekdayShort) === null || _d_weekdayShort === void 0 ? void 0 : _d_weekdayShort.toLowerCase())
        }, (_blocked_d_day = blocked[d.day]) === null || _blocked_d_day === void 0 ? void 0 : _blocked_d_day.map((b, i)=>/*#__PURE__*/ _react.default.createElement(BlockedTime, {
                key: i,
                timezone: timezone,
                ...b
            })), selectedTime != null && selectedTimeDay === d.day && /*#__PURE__*/ _react.default.createElement(SelectedTime, {
            timezone: timezone,
            ...selectedTime
        }));
    }))))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "6f046df116ebb685",
        dynamic: [
            theme.spacers.s6,
            theme.breakpoints.lg,
            theme.colors.border,
            theme.spacers.s5,
            theme.colors.border,
            theme.colors.border,
            theme.breakpoints.md + 1
        ]
    }, ".cal-holder.__jsx-style-dynamic-selector{overflow-x:auto;padding-top:10px}.header.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:0 0 ".concat(theme.spacers.s6, "}.calendar.__jsx-style-dynamic-selector{max-height:600px}.calendar.__jsx-style-dynamic-selector,.dates-heading.__jsx-style-dynamic-selector{display:grid;gap:2px;grid-template-columns:auto 1fr}@media(min-width:").concat(theme.breakpoints.lg, "px){.calendar.__jsx-style-dynamic-selector,.dates-heading.__jsx-style-dynamic-selector{gap:10px}}.days.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.dates-heading.__jsx-style-dynamic-selector{border-bottom:1px solid ").concat(theme.colors.border, "}.dates.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;text-align:center;font-size:14px;padding-bottom:").concat(theme.spacers.s5, "}.date.today.__jsx-style-dynamic-selector .date-number.__jsx-style-dynamic-selector{-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background:black;color:white;padding:.5em}.times.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.time-spacer.__jsx-style-dynamic-selector,.time.__jsx-style-dynamic-selector{width:40px}.time.__jsx-style-dynamic-selector{position:relative;height:60px;font-size:11px}.time.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{position:absolute;display:block;bottom:-9px;right:0}.date.__jsx-style-dynamic-selector,.day.__jsx-style-dynamic-selector{width:100px}.day.__jsx-style-dynamic-selector{display:grid;grid-template-rows:repeat(1440,1px);grid-template-columns:repeat(7,98px);padding:1px 1px 0;border:1px solid ").concat(theme.colors.border, ";border-width:0 1px 1px 0;background-image:-webkit-linear-gradient(").concat(theme.colors.border, " 1px,transparent 1px);background-image:-moz-linear-gradient(").concat(theme.colors.border, " 1px,transparent 1px);background-image:-o-linear-gradient(").concat(theme.colors.border, " 1px,transparent 1px);background-image:linear-gradient(").concat(theme.colors.border, " 1px,transparent 1px);-webkit-background-size:1px 60px;-moz-background-size:1px 60px;-o-background-size:1px 60px;background-size:1px 60px}.day.__jsx-style-dynamic-selector:first-child{border-width:0 1px 1px}.event.__jsx-style-dynamic-selector{opacity:.5}@media(min-width:").concat(theme.breakpoints.md + 1, "px){.date.__jsx-style-dynamic-selector,.day.__jsx-style-dynamic-selector{width:-webkit-calc(100%/7);width:-moz-calc(100%/7);width:calc(100%/7)}.day.__jsx-style-dynamic-selector{grid-template-columns:none;grid-auto-columns:1fr}}")));
};

//# sourceMappingURL=Calendar.js.map